import { Routes } from '@angular/router';
import { rootRoutes } from './routes';

export const environment = {
  production: false,
  mock: false,
  noticesUrl: `https://fs2.jgrants-portal.go.jp/${window.location.hostname}.json`,
  // 電子ロッカードメインを複数入力可能にする場合は、,(カンマ)区切りで指定して下さい
  // また末尾の/はロジックで付与している為、記載しなくて問題ありません
  denshiLockerUrl: 'https://ntt-2d--partial.sandbox.my.site.com/',
  denshiLockerDomain: 'ntt-2d--partial.sandbox.my.site.com',
};

const debugRoutes: Routes = [
  // 必要があればここにデバッグ用のRouteを追加する
];

export const routes: Routes = [...rootRoutes, ...debugRoutes];
